module.exports = __webpack_public_path__ + "img/reference-biohof-nofels.7b3ff2df.webp";